import getFetcher from 'api/utils/getFetcher';
import { useMemo } from 'react';
import useSWR from 'swr';
import type { StructsBillingAccountResponse } from 'types/__generated__/SimInventoryApi';
import { ApiBaseError } from '../utils/shared';

export interface BillingAccountResultError extends ApiBaseError {}

const useBillingAccount = (orgId?: OrgId) => {
  const queryParams = new URLSearchParams({ orgId: `${orgId}` });
  const url = orgId
    ? `${process.env.VITE_BIZ_API_ROOT}/sim-inventory/billing/account?${queryParams}`
    : null;

  const { data, error, isLoading, isValidating, mutate } = useSWR<
    StructsBillingAccountResponse,
    BillingAccountResultError
  >(url, getFetcher);

  const billingAccount = useMemo(() => data ?? {}, [data]);

  return {
    billingAccount,
    error,
    isLoading,
    isValidating,
    mutate,
  };
};

export default useBillingAccount;
